import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedIncidentCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface IncidentCreatedEventProps {
  event: DiscriminatedIncidentCreatedEvent;
}

export const IncidentCreatedEvent: React.FC<IncidentCreatedEventProps> = ({
  event,
}) => {
  const { incident } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-red-100">
          <ExclamationTriangleIcon className="h-4 w-4 text-red-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        {incident.date_of_loss && (
          <div className="text-sm text-gray-600">
            Date: {new Date(incident.date_of_loss).toLocaleDateString()}
          </div>
        )}
        {incident.incident_type && (
          <div className="text-xs text-gray-500">
            Type: {incident.incident_type}
          </div>
        )}
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Incident Reported"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
